import script from "./remark-tag-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./remark-tag-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__